import styles from '../css/main.scss' // import stylu , potreba uvest pro webpack aby zpracoval styly!!!
import { formData, globals as gl, setFormData, setGlobals } from './globals'
import { formSubmit } from './actions/submit'
import { generateModal } from './modal'
import { Modal } from './modalCls'
let $targetElement;
let groupHash, userHash;
let email_disabled;

// ### INIT ################################################################################################################################################################
const init = (opts, target) => {
  console.log(opts);
  $targetElement = target.empty();
  const defaults = {
    name: 'approval-form',
    prefix: 'approval-',
    localData: false,
    recaptchaKey: '6LcO71YUAAAAABhmIE0quFuVCkkskfCriCsxkNXm',
    groupHash: '',
    dataPath: 'https://dpl-dev-ares-qa.sa.cz/webapi/api/signatures/config',
    //      dataPath: 'https://webapi.sa.cz/services/api/signatures/config',
    updatePath: 'https://dpl-dev-ares-qa.sa.cz/webapi/api/signatures/update',
    //      updatePath: 'https://webapi.sa.cz/services/api/signatures/update',
    btnColor: '#00b5d7',
    checkTextColor: '#00b5d7',
    unsubscribe: false
  };

  opts = $.extend({}, defaults, opts);
  setGlobals(opts);

  if (gl.localData) { // nacitej lokalni json soubor pro debug
    gl.dataPath = './json/data.json';
  } 

  userHash = getUrlParameter('u');
  if (typeof userHash === 'undefined') { userHash = ''; }
  
  if (typeof gl.groupHash !== 'undefined' && gl.groupHash !== '') { 
    groupHash = gl.groupHash;
  }
  let dataUrl = `${gl.dataPath}/${groupHash}/${userHash}`;

  //userHash = "21cf8a98-6e48-11e8-adc0-fa7ae01bbebc";
  $.getJSON(dataUrl)
    .then(data => {
      setFormData(data);
      renderForm();
    })
    .fail(err => {
      console.error('Error loading layer data', err);
    });
};
// ### INIT ################################################################################################################################################################
//
// ### FORM ################################################################################################################################################################
const renderForm = () => { // tvorba checkboxu

  //  console.log('formdata',formData);
  const $form = $('<form />', {
    action: '/',
    id: 'approval-form',
    name: 'approval-form',
    'class': 'approval-form'
  });
  $form.appendTo($targetElement);
  //generateModal('Musíte zvolit zda-li souhlasíte či ne.').appendTo($form);



  const $contentBefore = $('<p />', {
    id: `${gl.prefix}content-before`,
    'class': `${gl.prefix}content-before`,
    html: formData.options.text_before
  }).appendTo($form);

  let $radio_yes = $('<input />', {
    type: 'radio',
    name: 'approval-radio-group',
    value: true,
    'class': 'radio-custom',
    checked: formData.sources[0].checked,
    id: `${gl.prefix}radio-yes`
  }).on('click', function (e) {
  }).appendTo($form);

  var $label_yes = $('<label />', {
    html: 'Souhlasím',
    css: { 'color': gl.checkTextColor },
    'class': 'radio-custom-label',
    for: `${gl.prefix}radio-yes`
  }).appendTo($form);


  let $radio_no = $('<input />', {
    type: 'radio',
    name: 'approval-radio-group',
    value: false,
    'class': 'radio-custom',
    checked: (formData.sources[0].checked === false) ? true : false,
    id: `${gl.prefix}radio-no`
  }).on('click', function (e) {

  }).appendTo($form);


  var $label_no = $('<label />', {
    html: 'Nesouhlasím',
    css: { 'color': gl.checkTextColor },
    'class': 'radio-custom-label',
    for: `${gl.prefix}radio-no`
  }).appendTo($form);

  $('<br />', {}).appendTo($form);

  const $contentAfter = $('<div />', {
    'id': `${gl.prefix}content-after`,
    'class': `${gl.prefix}content-after`,
    'html': formData.options.text_after
  }).appendTo($form);


  const $validation = $('<input />', {
    'type': 'text',
    'id': 'phone',
    'name': 'phone',
    'class': 'approval-phone',
    'css': {
      'display': 'none'
    },
    'value': ''
  }).appendTo($form);

  const $submitWrapper = $('<div />', {
    'class': `btn-wrapper`
  }).appendTo($form);

  let $submit = $('<input />', {
    type: 'submit',
    'name': 'approval_submit',
    'css': {
      'background-color': gl.btnColor,
      'opacity': 1
    },
    'class': 'approval_submit',
    'value': 'Potvrdit'
  })
    .hover(function () {
      $(this).css("opacity", "0.85");
    }, function () {
      $(this).css("opacity", "1");
    });

  $form.submit(function (e) {
    e.preventDefault();
    e.stopPropagation();
    formSubmit();
  });
  $submit.appendTo($submitWrapper);

/*   const dt = new Date();
  let now = 'Dne ' + dt.getDate().toString() + '. ' + dt.getMonth().toString() + '. ' + dt.getFullYear().toString();
  $('<div />', {
    html: now
  }).appendTo($form); */

};
// ### FORM ################################################################################################################################################################

(function ($) {
  $.support.cors = true;

  $.fn.extend({
    approvalForm: function (opts) {
      init(opts, this);
    }
  });
})(jQuery);

// ### FN ################################################################################################################################################################
const getUrlParameter = (sParam) => {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
};
// ### FN ################################################################################################################################################################



// WEBPACK FOOTER //
// ./app/main.js